// extracted by css-extract-rspack-plugin
export default {"visuallyHidden":"aUOd5_ow04wJwKYQ"};